import { TabStyles } from '@tableau/widgets';
import React from 'react';


export const Title: React.FC = ({ children }) => (
  <div style={{
    color: TabStyles.Typography.Color.Secondary,
    fontSize: TabStyles.Typography.Sizing.Large,
    paddingBottom: TabStyles.Spacing.DefaultSpace,
  }}>
    {children}
  </div>
);
